import { useMemo } from "react";
import { getTilePageMarkdown, getSelectedArticleMarkdown, getSelectedItemMarkdownFunction, getTopLevelPopdockScriptPageMarkdown } from "../functions/markdown.jsx";

export function useArticleCopyState(props) {
    const {
        SelectedArticle, HelpSiteViewBaseUrl,
        Title, Description, Articles, Ignore
    } = props;

    const copyState = useMemo(() => {
        if (Ignore)
            return null;

        if (!SelectedArticle || SelectedArticle?.PinToTop) {
            return {
                Slug: HelpSiteViewBaseUrl?.split("/").pop(),
                ItemHelpSiteUrl: `${HelpSiteViewBaseUrl}.md`,
                Markdown: getTilePageMarkdown(Title, Description, Articles, null, HelpSiteViewBaseUrl)
            };
        };

        return {
            Slug: SelectedArticle.Slug,
            ItemHelpSiteUrl: `${HelpSiteViewBaseUrl}/${SelectedArticle.Slug}.md`,
            Markdown: getSelectedArticleMarkdown(SelectedArticle, HelpSiteViewBaseUrl)
        };
    }, [Ignore, SelectedArticle, Title, Description, Articles, HelpSiteViewBaseUrl]);

    return copyState;
}

export function usePopdockScriptCopyState(props) {
    const {
        SelectedItem, Articles,
        HelpSiteViewBaseUrl, Ignore, CalculatedFields
    } = props;

    const copyState = useMemo(() => {
        if (Ignore)
            return null;

        if (SelectedItem === null) {
            return {
                Slug: HelpSiteViewBaseUrl?.split("/").pop(),
                ItemHelpSiteUrl: `${HelpSiteViewBaseUrl}.md`,
                Markdown: getTopLevelPopdockScriptPageMarkdown(Articles, CalculatedFields, HelpSiteViewBaseUrl)
            };
        }

        const fn = getSelectedItemMarkdownFunction(SelectedItem, HelpSiteViewBaseUrl);
        return {
            Slug: SelectedItem.Slug,
            ItemHelpSiteUrl: `${HelpSiteViewBaseUrl}/${SelectedItem.Slug}.md`,
            Markdown: typeof fn === "function" ? fn() : null
        };
    }, [Ignore, CalculatedFields, Articles, SelectedItem, HelpSiteViewBaseUrl]);

    return copyState;
}